import { Card, CardContent, Typography } from '@material-ui/core';
import { ReactNode } from 'react';
import styled from 'styled-components';

interface HomeScreenCardProps {
  icon: ReactNode;
  title: string;
  count?: number;
  onClick: () => void;
}

const Styled1 = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
`;

export function HomeScreenCard({
  icon,
  title,
  count,
  onClick,
}: HomeScreenCardProps) {
  return (
    <Card role="button" onClick={onClick}>
      <CardContent>
        <Styled1>
          {icon}

          <Typography variant="h3">{count}</Typography>
        </Styled1>

        <Typography>{title}</Typography>
      </CardContent>
    </Card>
  );
}
